var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13002 6.46763C6.13002 6.36942 6.21038 6.28906 6.30859 6.28906L7.78181 6.29576L10.0006 8.94085L12.2171 6.29799L13.6925 6.29129C13.7907 6.29129 13.8711 6.36942 13.8711 6.46987C13.8711 6.51228 13.8555 6.55246 13.8287 6.58594L10.9247 10.0458L13.8287 13.5033C13.8557 13.5361 13.8706 13.577 13.8711 13.6194C13.8711 13.7176 13.7907 13.798 13.6925 13.798L12.2171 13.7913L10.0006 11.1462L7.78404 13.7891L6.31083 13.7958C6.21261 13.7958 6.13225 13.7176 6.13225 13.6172C6.13225 13.5748 6.14788 13.5346 6.17466 13.5011L9.07422 10.0435L6.1702 6.58371C6.14342 6.55246 6.13002 6.51004 6.13002 6.46763Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.5223 0 20 4.47768 20 10C20 15.5223 15.5223 20 10 20C4.47768 20 0 15.5223 0 10C0 4.47768 4.47768 0 10 0ZM10 18.3036C14.5848 18.3036 18.3036 14.5848 18.3036 10C18.3036 5.41518 14.5848 1.69643 10 1.69643C5.41518 1.69643 1.69643 5.41518 1.69643 10C1.69643 14.5848 5.41518 18.3036 10 18.3036Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.73f24c71e04c19a236cb0ca8175112fc.svg";
export { ForwardRef as ReactComponent };